/*
 * @Descripttion:印度Pincode邮编查询城市接口
 * @Author: cmall
 * @Date: 2026-08-18
 */
import axios from 'axios'

//查询邮编对应城市
const lookupPincode = pincode =>
  axios
    .get('/api/v1/pincode/lookup', { params: { pincode } })
    .then(res => res.data)

export default { lookupPincode }
